import { setCustomer } from "../slices/customerSlice";
export const setCustomerAsync = (customer) => (dispatch) => {
    localStorage.setItem("customer", JSON.stringify(customer));
    dispatch(setCustomer(customer));
};
